import { AnnualReturnsCartState } from "@dana/Store/Data/AnnualReturnsCart/AnnualReturnsCartState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: AnnualReturnsCartState = {
    isLoading: false,
    loadSuccess: false,
    cart: null,
    errorMessage: '',
};

const reducer =  createTypedReducerWithImmer(initialState, {
    "AnnualReturnsCart/Start": (draft: Draft<AnnualReturnsCartState>, action: { isLoading: boolean, loadSuccess: boolean }) => {
        draft = { ...initialState, isLoading: action.isLoading, loadSuccess: action.loadSuccess };
        return draft;
    },
    "AnnualReturnsCart/LoadResponse": (draft: Draft<AnnualReturnsCartState>, action: { cart: CartModel, errorMessage: string }) => {
        draft = {
            ...draft,
            cart: action.cart,
            errorMessage: action.errorMessage
        };
        return draft;
    },
    "AnnualReturnsCart/End": (draft: Draft<AnnualReturnsCartState>, action: { isLoading: boolean, loadSuccess: boolean }) => {
        draft = { ...draft, isLoading: action.isLoading, loadSuccess: action.loadSuccess, };
        return draft;
    }
});

(reducers as any).annualReturnsCartState = reducer;

type AnnualReturnsCartReducers = {
    annualReturnsCartState: typeof reducer;
};

export type AnnualReturnsCartActions = Parameters<AnnualReturnsCartReducers[keyof AnnualReturnsCartReducers]>[1] | AnyAction;